import type { TFunction } from "i18next";
import type { MenuItem } from "@entur-partner/micro-frontend";
import type { BusinessCapability } from "@entur-partner/permission-client-node";
import { hasAllPermissions } from "@entur-partner/util";

import { ALARM_READ, APP_VERSIONS_CAPABILITIES, DEPLOYMENT_CAPABILITIES, MACHINE_READ } from "@/AccessPermissions.ts";
import config from "@/config.ts";

// Each item is filtered here AND carries requiredPermissions: the host shell
// doesn't enforce the field today, but it's the declared contract and costs
// nothing if it ever starts to.
export const getMenuItems = (
  t: TFunction,
  navigate: (path: string) => void,
  permissions: BusinessCapability[]
): MenuItem[] => {
  const items: MenuItem[] = [];

  // The overview is the root path, and Entur Partner adds its own row for a
  // micro-frontend's landing page. Only the standalone shell needs one from us.
  if (config.isStandalone && hasAllPermissions(MACHINE_READ, permissions)) {
    items.push({
      title: t("menu.overview"),
      to: "/",
      navigate: (path) => navigate(path),
      requiredPermissions: { all: MACHINE_READ }
    });
  }
  if (hasAllPermissions(ALARM_READ, permissions)) {
    items.push({
      title: t("menu.alarms"),
      to: "/alarms",
      navigate: (path) => navigate(path),
      requiredPermissions: { all: ALARM_READ }
    });
  }
  if (hasAllPermissions(DEPLOYMENT_CAPABILITIES, permissions)) {
    items.push({
      title: t("menu.deployment"),
      to: "/deployment",
      navigate: (path) => navigate(path),
      requiredPermissions: { all: DEPLOYMENT_CAPABILITIES }
    });
  }
  if (hasAllPermissions(APP_VERSIONS_CAPABILITIES, permissions)) {
    items.push({
      title: t("common.app-versions"),
      to: "/versions",
      navigate: (path) => navigate(path),
      requiredPermissions: { all: APP_VERSIONS_CAPABILITIES }
    });
  }

  return items;
};
